// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/scss/main.scss
// module id = hvFc
// module chunks = 1